import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import SlidegalleryItem from '../../containers/slidegallery-item';
import PhotoInfo from '../../containers/photo-info';

const SlidegalleryItemBlock = props => <SlidegalleryItem {...props} />;
SlidegalleryItemBlock.displayName = 'SlidegalleryItem';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(SlidegalleryItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/slidegallery-item/index.jsx